import { createApp } from 'vue'
import App from './App.vue'

import './index.css'
import router from './router'
import store from './store'
import i18n from './i18n' 
 

 
 
// treat all tags starting with 'ion-' as custom elements

createApp(App).use(i18n).use(router ).use(store).mount('#app')
